import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const LogService = {
  getErrorLogs: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/log/geterrorlogs`);
      return data;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default LogService;
